import { render, staticRenderFns } from "./addCustomerField.vue?vue&type=template&id=0637bfc2&lang=pug"
import script from "./addCustomerField.vue?vue&type=script&lang=js"
export * from "./addCustomerField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports